import { map, orderBy, omitBy, isNull, flow, omit } from 'lodash';
import { keysToCamelCase } from '../../utils/object';
import { guid } from '../../utils/guid';
import { parseJSON } from './parse-json';
const removeNullProperties = data => omitBy(data, isNull);
const parseCard = itemActionData => {
  const parsedVideoCard = keysToCamelCase(itemActionData);
  const {
    type,
    actionId,
    clientId,
    appearance,
    position,
    orientation,
    thumbnailUrl
  } = parsedVideoCard;
  const omittedProperties = ['actionId', 'clientId', 'type', 'appearance', 'position', 'orientation', 'parentItemId', 'dateCreated', 'dateUpdated'];
  const to = appearance ? appearance.start + appearance.duration : undefined;
  const parsedItemAction = {
    actionId,
    clientId: clientId || guid(),
    type,
    from: appearance == null ? void 0 : appearance.start,
    to,
    position,
    orientation,
    file: thumbnailUrl,
    ...omit(parsedVideoCard, omittedProperties)
  };
  return flow(removeNullProperties, parseJSON)(parsedItemAction);
};
export const parseCards = rawCards => {
  const videoCards = map(rawCards, parseCard);
  return orderBy(videoCards, ['from', 'updatedTimestamp'], ['asc', 'asc']);
};
//# sourceMappingURL=cards.js.map